import { render, staticRenderFns } from "./Credentials.vue?vue&type=template&id=dff322a2&scoped=true&"
import script from "./Credentials.vue?vue&type=script&lang=js&"
export * from "./Credentials.vue?vue&type=script&lang=js&"
import style0 from "./Credentials.vue?vue&type=style&index=0&id=dff322a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff322a2",
  null
  
)

export default component.exports